import { personalUrl } from "utils/env";

export const fetchTaxData = async (formData) => {
  try {
    const response = await fetch(`${personalUrl}tax`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify(formData),
    });
    if (response.ok) {
      const taxData = await response.json();

      return taxData;
    }
    return false;
  } catch (error) {
    return error;
  }
};

export const getCreditCardType = (firstDigit) => {
  const creditCardTypes = {
    3: "american express",
    4: "visa",
    5: "mastercard",
    6: "discover",
  };
  return creditCardTypes[firstDigit];
};

export const getHeaderText = (callLocation) => {
  switch (callLocation) {
    case "zipRecruiterPurchase":
      return "Thank you for purchasing ZipRecruiter Credits. Please update your Billing Information if necessary.";
    case "subscribe":
      return "Thank you for deciding to renew your subscription to Criteria. Your new subscription will start on the date that your current subscription ends, not necessarily the day you renew. Please update your Billing Information if necessary.";
    case "versionUpgrade":
    default:
      return "Thank you for deciding to upgrade your subscription to Criteria. Please update your Billing Information if necessary.";
  }
};
